<template>
  <div>
    <span id="loading" v-if="this.loading == true">
      <Loading />
    </span>
    <div class="card">
      <h3 class="title">Encomenda nº: {{ orderId }}</h3>
      <hr />
      <div class="row">
        <div class="col">
          <h4>Transportadora:</h4>
          <h3>FedEx</h3>
        </div>
        <div class="col">
          <h4>Expedição nº:</h4>
          <h3>{{ expedition }}</h3>
        </div>
        <div class="col">
          <h4>Tracking:</h4>
          <a @click="openTracking(tracking)"
            ><h3>{{ tracking }}</h3></a
          >
        </div>
        <div class="col">
          <h4>Etiqueta</h4>
          <button class="btn btn-primary mb-2" @click="getLabel()">
            Etiqueta
          </button>
        </div>
        <div class="col">
          <h4>Cancelar</h4>
          <button
            class="btn btn-primary mb-2"
            @click="cancelExpedition(tracking)"
          >
            <h4>Cancelar</h4>
          </button>
        </div>
        <div class="col">
          <h4>Fatura</h4>
          <span v-if="this.order[0].id_invoice == 0"
            >Fatura criada Manualmente</span
          >
          <span v-else>
            <button
              class="btn btn-primary mb-2"
              @click="
                openFile(order[0].id_invoice || order[0].credit_note_invoice_id)
              "
            >
              {{ order[0].id_invoice || order[0].credit_note_invoice_id }}
            </button>
          </span>
        </div>
        <div
          class="col"
          v-if="
            this.order[0].send_email == '' || this.order[0].send_email == null
          "
        >
          <button class="btn btn-primary mb-2" @click="sendEmail()">
            Enviar Email
          </button>
        </div>
        <div v-else class="col">
          <h5>Email enviado</h5>
          <button class="btn btn-primary mb-2" @click="sendEmail(true)">
            Reenviar Email
          </button>
        </div>
        <div class="col">
          <h5>Nota de Crédito</h5>
          <button
            class="btn btn-info"
            v-if="role == 'admin' && this.order[0].credit_note_id == null"
            @click="creditNoteCreation(order[0].id, order[0].id_invoice)"
          >
            Fazer nota de crédito
          </button>
          <button
            class="btn btn-primary"
            v-else-if="this.order[0].credit_note_id != null"
          >
            {{ this.order[0].credit_note_id }}
          </button>
          <span v-else><b>Não existe Nota de Crédito</b></span>
        </div>
      </div>
    </div>
    <div class="card">
      <table>
        <td><h3 class="title">Estados do tracking</h3></td>
        <td>
          <h5 class="title" v-if="trackingStatus.delivered_status == true">
            <b style="background-color: green">Entregue</b>
          </h5>
          <b-button
            v-else
            @click="confirmDelivered()"
            class="btn btn-secondary mb-2"
            >Marcar como entregue</b-button
          >
        </td>
      </table>
      <hr />
      <table>
        <td>
          <b>Data de Envio:</b> {{ splitDate2(trackingStatus.send_date) }}
        </td>
        <td v-if="trackingStatus.max_date != null">
          <b>Data máx. entrega:</b> {{ splitDate2(trackingStatus.max_date) }}
        </td>
        <td v-if="trackingStatus.email_date != null">
          <b>Data email enviado:</b> {{ splitDate2(trackingStatus.email_date) }}
        </td>
        <td>
          <button class="btn btn-primary mb-2" @click="sendEmailTrans()">
            Enviar Email Transportadora
          </button>
        </td>
      </table>
      <hr v-if="this.order[0].insurance != null" />
      <h4 v-if="this.order[0].insurance != null">
        <u>Seguro Recebido:</u> <b>{{ this.order[0].insurance }} €</b>
      </h4>
      <hr />
      <span v-if="trackingStatusMovements.length == 0" style="font-size: larger"
        ><b>Sem movimentos</b>
      </span>
      <table v-else>
        <tr>
          <th>Data</th>
          <th>Estado</th>
          <th>Des. do Estado</th>
        </tr>
        <tr v-for="status in trackingStatusMovements" :key="status.code">
          <td>{{ splitDate(status.date) }}</td>
          <td>{{ status.event }}</td>
          <td>{{ status.code_des }}</td>
          <hr />
        </tr>
      </table>
      <hr />
      <div class="return" v-if="this.order[0].status == 'completed'">
        <span v-if="splitDate2(trackingStatus.send_date) == dateNow"
          ><button class="btn btn-primary" @click="internReturn()">
            Devolução Interna
          </button></span
        >
        <span v-else
          ><button class="btn btn-primary" @click="openModal()">
            Encomenda Devolvida
          </button></span
        >
      </div>
      <div v-else-if="this.order[0].status == 'returned'">
        <h5><b>Devolução</b></h5>
        <br />
        <button
          id="returnedProducts"
          class="btn btn-info"
          @click="returnedProducts()"
        >
          Ver produtos devolvidos</button
        ><br />
        <button
          class="btn btn-success"
          id="processing"
          @click="updateOrder('processing')"
        >
          Para Processamento
        </button>
        <button
          class="btn btn-primary"
          id="finish"
          @click="updateOrder('finish')"
        >
          Finalizar
        </button>
      </div>
      <div v-else-if="this.order[0].status == 'confirmed/returned'">
        <h5>Encomenda devolvida com sucesso</h5>
      </div>
      <div
        v-else-if="
          this.order[0].status == 'lost_with_insurance' ||
          this.order[0].status == 'lost_without_insurance'
        "
      >
        <h5>Quer criar nova encomenda?</h5>
        <button
          class="btn btn-success"
          id="processing"
          @click="duplicateOrder(true)"
        >
          Sim
        </button>
        <button
          class="btn btn-warning"
          id="processing"
          @click="duplicateOrder(true)"
        >
          Não
        </button>
        <br />
        <button class="btn btn-primary" @click="alertToPassToReturn()">
          Encomenda Devolvida
        </button>
      </div>
      <div
        id="returnComment"
        v-if="
          this.order[0].return_comment != null ||
          this.order[0].return_comment != ''
        "
      >
        <b>Comentário à devolução</b>
        <p>{{ this.order[0].return_comment }}</p>
      </div>
    </div>
    <b-modal
      ref="modal_return"
      id="modal-4"
      title="Devolução"
      size="xl"
      hide-footer
    >
      <!-- 1) SKU input + Pick + Finalizar -->
      <div class="d-flex mb-3">
        <input
          v-model="skuInput"
          type="text"
          class="form-control mr-2"
          placeholder="Insira o SKU ou EAN"
          @input="handleInput"
          @paste="handlePaste($event)"
          @keyup="handleAcceptKeyPressPicking"
        />
        <!-- Ícone para desbloquear colagem -->
        <div class="input-group-append" v-if="!pasteAllowed">
          <span
            class="input-group-text unlock-icon"
            title="Desbloquear colagem"
            @click="openAcceptModal"
          >
            <i class="fas fa-unlock-alt"></i>
          </span>
        </div>

        <button class="btn btn-secondary mr-2" @click="pickProduct()">
          Pick
        </button>
        <!-- FINALIZAR is disabled until allClosed -->
        <button
          class="btn btn-success"
          @click="finalizeReturn"
          :disabled="this.pickedArticles.length == 0"
        >
          Finalizar
        </button>
      </div>

      <!-- 2) List of products -->
      <ul class="list-group mb-3">
        <li
          v-for="(article, index) in allArticles"
          :key="article.sku"
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          <span
            :class="{
              'text-muted': article.closed,
              'text-decoration-line-through': article.closed,
            }"
          >
            {{
              (pickedArticles.find((p) => p.sku === article.sku)?.quantity ||
                0) +
              '/' +
              article.quantity +
              ' ' +
              article.sku +
              ' ' +
              article.name
            }}
          </span>
          <span>
            <date-picker
              v-model="products[index].validity"
              type="month"
              format="YYYY-MM"
              value-type="format"
              :lang="lang"
              required
            ></date-picker>
          </span>
          <span v-if="article.closed" class="badge badge-secondary"
            >Fechado</span
          >
        </li>
      </ul>

      <!-- 3) Comments -->
      <div>
        <label for="return-comments">Comentários</label>
        <textarea
          id="return-comments"
          class="form-control"
          rows="2"
          v-model="comment"
        ></textarea>
      </div>
    </b-modal>
    <b-modal
      ref="modal_product"
      id="modal-3"
      title="Produto"
      size="lg"
      hide-footer
    >
      <div class="card">
        <b-container>
          <b-row align-v="center"
            ><b-col class="left">
              <!-- IMAGEM DO PRODUTO -->
              <img :src="imgProduct" />
            </b-col>
            <b-col>
              <p><span id="subtitle">STOCK: </span> {{ stockProduct }}</p>
              <p><span id="subtitle">EAN:</span> {{ eanProduct }}</p>
              <p><span id="subtitle">SKU:</span> {{ skuProduct }}</p>
              <p><span id="subtitle">HS Code:</span> {{ hsProduct }}</p>
              <p>
                <span id="subtitle">Notas Arm.:</span>
                {{ warehouseProduct }}
              </p>
              <p><span id="subtitle">Notas:</span> {{ notesProduct }}</p>
              <p><span id="subtitle">Peso:</span> {{ weightProduct }} (g)</p>
            </b-col></b-row
          >
        </b-container>
        <button class="btn btn-info" @click="openProdPage()">
          Editar Produto
        </button>
      </div>
    </b-modal>
    <b-modal
      ref="modal_returned_products"
      id="modal-5"
      title="Produtos devolvidos"
      size="lg"
      hide-footer
    >
      <div v-for="prod of allReturnedProducts" :key="prod.id">
        <p>
          <b>{{ prod.sku }}</b> - <u>{{ prod.quantity }}x</u> {{ prod.name }}
        </p>
        <hr />
      </div>
    </b-modal>
    <!-- Modal para aceitar os riscos -->
    <b-modal ref="acceptModal" title="Desbloquear Colagem" hide-footer>
      <div class="modal-body">
        <p class="text-justify">
          Recomendamos a leitura do código de barras (picagem), que é mais
          segura e eficiente. Caso opte por colar, confirme que entende os
          riscos escrevendo <strong>"S"</strong> no campo abaixo e pressione
          Enter.
        </p>
        <input
          type="text"
          class="form-control"
          v-model="acceptInput"
          placeholder="Digite 'S'"
          @keyup="handleAcceptKeyPress"
        />
      </div>
      <div class="modal-footer text-right">
        <button
          class="btn btn-success btn-sm rounded"
          :disabled="acceptInput.trim().toLowerCase() !== 's'"
          @click="allowPaste"
        >
          Confirmar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';
export default {
  components: {
    Loading,
  },
  props: {
    orderId: String,
    expedition: String,
    label: String,
    tracking: String,
    order: Array,
    articles: Array,
    price_eur: Number,
  },
  data: function () {
    return {
      pasteAllowed: false,
      acceptInput: '',
      pickedArticles: [],
      skuInput: '',
      canFinalize: false,
      loading: false,
      allProducts: [],
      allArticles: JSON.parse(this.order[0].articles),
      eanProduct: '',
      skuProduct: '',
      hsProduct: '',
      warehouseProduct: '',
      notesProduct: '',
      weightProduct: '',
      imgProduct: '',
      idProduct: '',
      stockProduct: '',
      comment: '',
      trackingStatus: '',
      trackingStatusMovements: '',
      products: [],
      allReturnedProducts: [],
      dateNow: '',
      role: '',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          months: [
            'janeiro',
            'fevereiro',
            'março',
            'abril',
            'maio',
            'junho',
            'julho',
            'agosto',
            'setembro',
            'outubro',
            'novembro',
            'dezembro',
          ],
          // MMM
          monthsShort: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
          ],
          // dddd
          weekdays: [
            'Domingo',
            'Segunda-feira',
            'Terça-feira',
            'Quarta-feira',
            'Quinta-feira',
            'Sexta-feira',
            'Sábado',
          ],
          // ddd
          weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          // dd
          weekdaysMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Se', 'Sa'],
        },
      },
    };
  },
  methods: {
    processEAN() {
      // Função para processar o valor do EAN
      console.log('Código EAN recebido:', this.ean);
      // Adicione aqui a lógica para verificar o EAN ou enviar para o servidor
    },
    handlePaste(event) {
      if (!this.pasteAllowed) {
        event.preventDefault();
        this.$swal({
          icon: 'warning',
          title: 'Colagem Bloqueada',
          text: 'A colagem está desativada. Utilize o leitor de código de barras.',
        });
      }
    },
    handleInput(event) {
      // Captura o valor atual do campo
      const currentInput = event.target.value;

      // Validação imediata: Se o comprimento do input for >= 8, processa diretamente
      if (currentInput.length >= 7) {
        this.ean = currentInput;
        console.log('Leitor de código de barras detectado:', this.ean);
        this.processEAN(); // Processa o código de barras
        clearTimeout(this.inputTimeout); // Cancela qualquer validação futura
        this.inputStartTime = null; // Reseta o timer
        return;
      }

      // Inicia o tempo quando o usuário começa a inserir dados
      if (!this.inputStartTime) {
        this.inputStartTime = new Date().getTime();
      }

      // Permite o usuário adicionar "0" manualmente
      if (currentInput === '0' || currentInput.endsWith('0')) {
        this.ean = currentInput; // Atualiza o valor normalmente
        console.log('Zero adicionado manualmente:', this.ean);
        return;
      }

      // Limpa o temporizador anterior
      clearTimeout(this.inputTimeout);

      // Adiciona um pequeno atraso para detectar o final da entrada
      this.inputTimeout = setTimeout(() => {
        const inputEndTime = new Date().getTime();
        const totalTime = inputEndTime - this.inputStartTime;

        // Valida se a entrada foi rápida (ex: leitor de código de barras)
        if (totalTime < 500 || this.pasteAllowed) {
          console.log('Entrada válida:', this.ean);
          this.processEAN(); // Processa o valor final do código
        } else {
          console.log('Entrada manual detectada, bloqueando...');
          this.ean = ''; // Reseta o campo
          this.$swal({
            icon: 'warning',
            title: 'Entrada Manual Bloqueada',
            text: 'Utilize o leitor de código de barras.',
          });
        }

        // Reseta o tempo de início
        this.inputStartTime = null;
      }, 200); // Atraso de 200ms para aguardar a pausa
    },

    handleAcceptKeyPress(event) {
      if (event.key === 'Enter') {
        this.allowPaste(); // Chama a função que desbloqueia a colagem
        console.log('enter pressed');
      }
    },
    handleAcceptKeyPressPicking(event) {
      if (event.key === 'Enter') {
        this.pickProduct(); // Chama a função que processa o SKU
        console.log('enter pressed');
      }
    },
    allowPaste() {
      if (this.acceptInput.trim().toLowerCase() === 's') {
        this.pasteAllowed = true;
        this.acceptInput = '';
        this.$refs.acceptModal.hide();
        this.$swal({
          icon: 'success',
          title: 'Desbloqueado',
          text: 'Agora você pode colar ou introduzir manualmente o EAN.',
        });
      }
    },
    openAcceptModal() {
      this.$refs.acceptModal.show();
    },
    finalizeReturn() {
      // if (!this.canFinalize) return;
      // your existing confirmation logic
      this.$refs.modal_return.hide();
      this.confirmModal();
    },
    pickProduct() {
      const sku = this.skuInput.trim();
      const idx = this.allArticles.findIndex(
        (a) => !a.closed && (a.sku === sku || a.ean === sku)
      );

      // not found?
      if (idx === -1) {
        return this.$swal(
          'SKU não encontrado',
          'Verifique o código e tente novamente.',
          'error'
        );
      }

      // decrement reactively
      const product = {
        ...this.allArticles[idx],
      };
      // const newQty = product.quantity - 1;
      // this.$set(this.allArticles[idx], 'quantity', newQty);
      // console.log(
      //   `Decremented quantity of ${product.sku} to ${this.allArticles[idx].quantity}`
      // );

      // if it hits zero, mark it closed
      // if (newQty <= 0) {
      //   this.$set(this.allArticles[idx], 'closed', true);
      // }

      // se sku nao esta em pickedArticles, adiciona com quantity 1, senao incrementa quantity
      const pickedIdx = this.pickedArticles.findIndex((a) => a.sku === sku);
      if (pickedIdx === -1) {
        this.pickedArticles.push({ ...product });
        this.pickedArticles[this.pickedArticles.length - 1].quantity = 1;
        if (
          parseFloat(
            this.pickedArticles[this.pickedArticles.length - 1].quantity
          ) >= parseFloat(product.quantity)
        ) {
          console.log(
            this.pickedArticles[this.pickedArticles.length - 1].quantity
          );
          console.log(product.quantity);
          this.$set(this.allArticles[idx], 'closed', true);
        }
      } else {
        this.pickedArticles[pickedIdx].quantity += 1;
        if (
          parseFloat(this.pickedArticles[pickedIdx].quantity) >=
          parseFloat(product.quantity)
        ) {
          this.$set(this.allArticles[idx], 'closed', true);
        }
      }
      // recompute canFinalize: all must be closed
      // this.canFinalize = this.allArticles.every((a) => a.closed);

      // clear input
      this.skuInput = '';
    },
    async openProdPage() {
      window.open(
        `https://${window.location.host}/product/${this.idProduct}`,
        '_blank'
      );
      this.$refs['modal_product'].hide();
    },
    async changeStatus() {
      this.$swal({
        title: 'Esta encomenda ficará como tratada',
        text: 'Caso aceite esta encomenda ficará como tratada sem ser gerada uma nova encomenda!',
        showCancelButton: true,
        confirmButtonText: 'Sim',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$store.dispatch('statusUpdate', {
              id: this.orderId,
              status: `${this.order[0].status}/confirmed`,
            });
            this.$swal.fire(`Encomenda tratada`, '', 'success');
          } catch (err) {
            alert(err);
          }
        }
      });
    },
    async duplicateOrder() {
      this.$swal({
        title: 'Será criada uma nova encomenda e gerada nota de crédito',
        html: `<input type="text" id="justification" class="form-control" placeholder="Notas" required>`,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        preConfirm: () => {
          const justification = document.getElementById('justification').value;
          if (!justification) {
            this.$swal.showValidationMessage('Justificação necessária');
          }
          return { justification: justification };
        },
      }).then(async (result) => {
        let justification = result.value.justification;
        if (result.isConfirmed) {
          try {
            await this.$store.dispatch('duplicateOrder', {
              id: this.orderId,
              newInvoice: true,
              notes: justification,
            });
            this.$swal.fire(
              `Encomenda P-${this.orderId} criada`,
              '',
              'success'
            );
          } catch (err) {
            alert(err);
          }
        }
        // else if (result.isDenied) {
        //   this.$swal({
        //     title: "Criar nota de crédito?",
        //     text: "Quer criar uma nota de crédito da fatura original?",
        //     showCancelButton: true,
        //     confirmButtonText: "Sim",
        //     denyButtonText: "Não",
        //   }).then(async (result) => {
        //     if (result.isConfirmed) {
        //       //TODO: Criar nota de crédito
        //       try {
        //         await this.$store.dispatch("duplicateOrder", {
        //           id: this.orderId,
        //           newInvoice: true,
        //         });
        //         this.$swal.fire(
        //           `Encomenda P-${this.orderId} criada`,
        //           "Nota de Crédito criada",
        //           "success"
        //         );
        //       } catch (err) {
        //         alert(err);
        //       }
        //     }
        //   });
        // }
      });
    },
    async getLabel() {
      const label = this.label;

      if (!label) {
        throw new Error('A etiqueta não foi recebida.');
      }

      const base64 = label
        .replace(/^data:application\/pdf;base64,/i, '')
        .replace(/\s/g, '');

      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);

      for (let index = 0; index < binaryString.length; index++) {
        bytes[index] = binaryString.charCodeAt(index);
      }

      const pdfBlob = new Blob([bytes], {
        type: 'application/pdf',
      });

      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, '_blank');

      window.setTimeout(() => {
        window.URL.revokeObjectURL(pdfUrl);
      }, 60000);

      console.log(this.order[0]);
      console.log(this.articles);
    },
    async openTracking(tracking) {
      window.open(
        `https://www.fedex.com/fedextrack/?trknbr=${tracking}`,
        '_blank'
      );
    },
    async sendEmail(resend = false) {
      this.loading = true;
      console.log(this.selected);
      try {
        await this.$store.dispatch('fetchEmail', {
          order: this.order[0],
          company: 'fedex',
          trackingId: this.tracking,
          resend: resend,
          price_eur: this.price_eur,
        });
        await this.$parent.getOrder();
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Email enviado!!',
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      } finally {
        this.loading = false;
      }
    },
    async setDataInfinity(product) {
      console.log('Infinito');
      product.validity = '2050-01';
      console.log(product);
    },
    async cancelExpedition(tracking) {
      this.loading = true;
      try {
        await this.$store.dispatch('cancelFedexShipment', {
          tracking: tracking,
          id: this.orderId,
        });
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Expedição cancelada com sucesso',
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      } finally {
        await this.$parent.getOrder();
        this.loading = false;
      }
    },
    async openFile(id) {
      console.log(id);
      try {
        await this.$store.dispatch('fetchPDFLink', {
          id: id,
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    async getTracking_fun() {
      const id = this.$route.params.id;
      try {
        await this.$store.dispatch('getTracking', {
          order: id,
        });
        this.trackingStatus = this.getTracking;
        this.trackingStatusMovements = this.getTracking.movements;
      } catch (err) {
        console.log(err);
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      console.log('TRACKINGGG', id, this.getTracking);
    },
    async sendEmailTrans() {
      const id = this.$route.params.id;
      try {
        await this.$store.dispatch('sendEmailTransport', {
          id: id,
        });
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Email Enviado',
          showConfirmButton: false,
          timer: 1500,
        });
        await this.getTracking_fun();
      } catch (err) {
        console.log(err);
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    splitDate(date) {
      let split = date.split('T');
      let split2 = split[1].split('.');
      return split[0] + ' ' + split2[0];
    },
    splitDate2(date) {
      let split = date.split('T');
      return split[0];
    },
    async getAllProducts() {
      console.log(this.xml);
      try {
        await this.$store.dispatch('fetchProducts');
        this.allProducts = this.getProducts.data;
      } catch (err) {
        alert(err);
      }
    },
    async passProductData(data) {
      console.log(data);
      const filterProduct = this.allProducts.filter((product) =>
        product.sku.includes(data.sku)
      );
      console.log(filterProduct);
      this.eanProduct = filterProduct[0].ean;
      this.skuProduct = filterProduct[0].sku;
      this.hsProduct = filterProduct[0].hscode;
      this.warehouseProduct = filterProduct[0].note_warehouse;
      this.notesProduct = filterProduct[0].note_finish;
      this.weightProduct = filterProduct[0].weight;
      this.imgProduct = filterProduct[0].img;
      this.idProduct = filterProduct[0].id_backoffice;
      this.stockProduct = filterProduct[0].stock;
      console.log(this.eanProduct);
      console.log(this.skuProduct);
      console.log(filterProduct, data);
    },
    async confirmModal() {
      await this.$swal({
        title: 'Confirma que esta encomenda é uma devolução?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, confirmo!',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            // 1) Construir lista de validades dos artigos escolhidos
            const pickedValidities = this.pickedArticles.reduce(
              (acc, { sku }) => {
                const prod = this.products.find((p) => p.sku === sku);
                if (prod) acc.push({ sku: prod.sku, validity: prod.validity });
                return acc;
              },
              []
            );

            // Helpers locais para datas
            const startOfMonth = (d) => {
              const x = new Date(d);
              x.setDate(1);
              x.setHours(0, 0, 0, 0);
              return x;
            };
            const parseValidity = (val) => {
              if (!val) return null;
              const s = String(val).trim();
              const norm = s.includes('T') ? s : s.length === 7 ? `${s}-01` : s;
              const d = new Date(norm);
              return isNaN(d.getTime()) ? null : startOfMonth(d);
            };

            // 2) Bucketizar por validade (<6M e 6–9M)
            const now = new Date();
            const lim6 = startOfMonth(
              new Date(now.getFullYear(), now.getMonth() + 6, 1)
            );
            const lim9 = startOfMonth(
              new Date(now.getFullYear(), now.getMonth() + 9, 1)
            );

            const under6 = [];
            const between6and9 = [];

            for (const item of pickedValidities) {
              const v = parseValidity(item.validity);
              if (!v) continue;
              if (v < lim6) {
                under6.push(item);
              } else if (v >= lim6 && v < lim9) {
                between6and9.push(item);
              }
            }

            // 3) Se houver validades baixas, pedir justificação obrigatória
            let validityJustification = null;
            if (under6.length || between6and9.length) {
              let canProceed = true; // ou remove isto e faz "return" no else, como preferires

              await this.$swal({
                title:
                  'Justificação das validades baixas - FALAR COM O RESPONSÁVEL',
                html: `
                  <textarea id="return_validity_justification"
                    class="form-control"
                    rows="3"
                    placeholder="Descreva o motivo (ex.: acordo com fornecedor, lote próximo da validade, etc.)"></textarea>
                `,
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                showCancelButton: true,
                allowOutsideClick: false, // não fecha ao clicar fora
                focusConfirm: false, // não rouba foco para o botão
                stopKeydownPropagation: true, // 🔑 impede que o teu listener global apanhe as teclas
                didOpen: () => {
                  const el = document.getElementById(
                    'return_validity_justification'
                  );
                  if (el) {
                    el.focus();
                    // extra segurança: não deixar keydown “sair” do textarea
                    el.addEventListener('keydown', (e) => e.stopPropagation());
                  }
                  // opcional: se tiveres um flag para o teu scanner, pausa-o aqui
                  this._scannerPaused = true;
                },
                willClose: () => {
                  // retoma o scanner/atalhos se usares um flag
                  this._scannerPaused = false;
                },
                preConfirm: () => {
                  const justification = this.$swal
                    .getPopup()
                    .querySelector('#return_validity_justification')
                    ?.value?.trim();

                  if (!justification) {
                    this.$swal.showValidationMessage(
                      'Por favor, forneça uma justificação'
                    );
                    return false;
                  }
                  if (justification.length > 500) {
                    this.$swal.showValidationMessage('Máx. 500 caracteres.');
                    return false;
                  }
                  return justification;
                },
              }).then((res) => {
                if (res.isConfirmed) {
                  validityJustification = res.value;
                } else {
                  canProceed = false;
                }
              });

              if (!canProceed) return;
            }

            // 4) Logs úteis
            console.log('Order ID-> ', this.orderId);
            console.log('All Articles-> ', this.pickedArticles);
            console.log('Comment-> ', this.comment);
            console.log('Validities-> ', pickedValidities);

            //Quero adicionar a justificação apenas se houver validades baixas e adicionar ao sku em especifico
            const affectedSkus = new Set(
              [...under6, ...between6and9].map((i) => i.sku)
            );

            // Enriquecer o array 'pickedValidities' só para os SKUs afetados
            const validityPayload = pickedValidities.map((v) =>
              affectedSkus.has(v.sku) && validityJustification
                ? { ...v, validity_justification: validityJustification } // campo por SKU
                : v
            );

            // 5) Dispatch com justificação incluída
            await this.$store.dispatch('returnedOrder', {
              id: this.orderId,
              articles: this.pickedArticles,
              comment: this.comment,
              validity: validityPayload,
            });

            // 6) UI feedback & fechar modal
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: `Encomenda ${this.orderId} devolvida!`,
              showConfirmButton: false,
              timer: 1500,
            });
            this.order[0].status = 'returned';
            this.$refs['modal_return'].hide();
          } catch (err) {
            console.log(err);
          }
        }
      });
    },
    async productsOrder() {
      this.products = [];
      let validity = '';
      for (let index = 0; index < this.allArticles.length; index++) {
        /* console.log(this.articles.length - 1, index); */
        let product = this.allArticles[index];
        if (product.validity != null) {
          validity = product.validity.substring(0, 7);
          if (validity != '2050-01') {
            validity = '';
          }
        }
        this.products.push({ sku: product.sku, validity: validity });
      }
      console.log(this.products);
    },
    openModal() {
      this.$refs['modal_return'].show();
    },
    async updateOrder(status) {
      let title =
        "Confirma que esta encomenda irá para o estado 'Em processamento'";
      if (status == 'finish') {
        title =
          "Confirma que esta encomenda irá para o estado 'Completa/Devolvida'";
      }
      await this.$swal({
        title: 'Quer criar uma nota de crédito?',
        icon: 'question',
        showDenyButton: true,
        denyButtonText: 'Não',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        denyButtonColor: '#d33',
        confirmButtonText: 'Sim, quero!',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$swal({
            title: title,
            html: `<p>Irá ser feita nota de crédito da encomenda ${this.orderId}<p><input type="text" id="justification" class="form-control" placeholder="Notas" required>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, confirmo!',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
              const justification =
                document.getElementById('justification').value;
              if (!justification) {
                this.$swal.showValidationMessage('Justificação necessária');
              }
              return { justification: justification };
            },
          }).then(async (result) => {
            let justification = result.value.justification;
            if (result.isConfirmed) {
              // TODO: Criar Nota de Crédito
              try {
                await this.$store.dispatch('updateStatusOrder', {
                  id: this.orderId,
                  orderData: this.order,
                  status: status,
                  notes: justification,
                });
                this.$swal({
                  toast: true,
                  position: 'top-end',
                  icon: 'success',
                  title: `Encomenda ${this.orderId} atualizada com sucesso!`,
                  showConfirmButton: false,
                  timer: 1500,
                });
              } catch (err) {
                alert(err);
              }
              this.order[0].status = 'confirmed/returned';
            }
          });
        }
        if (result.isDenied) {
          try {
            await this.$store.dispatch('updateStatusOrder', {
              id: this.orderId,
              orderData: this.order,
              status: status,
              notes: '',
              creditNote: false,
            });
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: `Encomenda ${this.orderId} atualizada com sucesso!`,
              showConfirmButton: false,
              timer: 1500,
            });
            this.order[0].status = 'confirmed/returned';
          } catch (err) {
            alert(err);
          }
        }
      });
    },
    async setOrderDelivered() {
      try {
        await this.$store.dispatch('setOrderDelivered', {
          order_id: this.order[0].id,
        });
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Estado alterado para entregue',
          showConfirmButton: false,
          timer: 1500,
        });
        location.reload();
      } catch (err) {
        console.log(err);
        alert(err);
      }
    },
    async confirmDelivered(order) {
      this.$swal({
        title:
          'Quer colocar a encomenda ' + this.order[0].id + ' como entregue?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.setOrderDelivered(order);
        }
      });
    },
    async returnedProducts() {
      const id = this.$route.params.id;
      this.$refs['modal_returned_products'].show();
      try {
        await this.$store.dispatch('returnedProducts', {
          idOrder: id,
        });
        this.allReturnedProducts = this.getReturnedProducts;
        console.log(this.allReturnedProducts);
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Encomenda Devolvida',
          showConfirmButton: false,
          timer: 1500,
        });
        //location.reload();
      } catch (err) {
        console.log(err);
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: err,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    async date() {
      let newDate = new Date();
      let day = ('0' + newDate.getDate()).slice(-2);
      let month = ('0' + (newDate.getMonth() + 1)).slice(-2);
      let year = newDate.getFullYear();
      this.dateNow = `${year}-${month}-${day}`;
    },
    async internReturn() {
      let advance;
      let justification = ''; // Variável para armazenar a justificativa

      await this.$swal({
        title: 'Quer fazer Devolução Interna?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, quero!',
        cancelButtonText: 'Cancelar',
      }).then(async (result2) => {
        if (result2.isConfirmed) {
          advance = true;
        } else {
          advance = false;
        }
      });

      if (advance === true) {
        await this.$swal({
          title: 'Será criada uma nota de crédito!',
          icon: 'question',
          html: `<input type="text" id="justification-input" class="swal2-input" placeholder="Escreva a justificação">`, // Caixa de texto para justificativa
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Avançar',
          cancelButtonText: 'Cancelar!',
          preConfirm: () => {
            justification = document.getElementById(
              'justification-input'
            ).value;
            if (!justification) {
              this.$swal.showValidationMessage('A justificação é obrigatória');
            }
            return justification;
          },
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.$store.dispatch('internReturn', {
                id: this.orderId,
                newInvoice: true,
                justification: justification, // Passa a justificativa para a ação
              });
              this.$swal({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Encomenda Devolvida',
                showConfirmButton: false,
                timer: 1500,
              });
              location.reload();
            } catch (err) {
              alert(err);
            }
          }
        });
      }
    },
    async userRole() {
      this.role = JSON.parse(localStorage.getItem('user')).role;
    },
    async creditNoteCreation(idOrder, idInvoice) {
      this.$swal({
        title: 'Quer criar uma nota de crédito?',
        html: `<input type="text" id="justification" class="form-control" placeholder="Notas" required>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, quero!',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          const justification = document.getElementById('justification').value;
          if (!justification) {
            this.$swal.showValidationMessage('Justificação necessária');
          }
          return { justification: justification };
        },
      }).then(async (result) => {
        let justification = result.value.justification;
        if (result.isConfirmed) {
          try {
            await this.$store.dispatch('createCreditNote', {
              idOrder: idOrder,
              idInvoice: idInvoice,
              notes: justification,
            });
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: 'Nota de crédito criada',
              showConfirmButton: false,
              timer: 1500,
            });
          } catch (err) {
            alert(err);
          }
        }
      });
    },
    async alertToPassToReturn() {
      this.$swal({
        title:
          'A encomenda foi dada como Perdida. Tem a certeza que quer passa-la para Devolvida?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, quero!',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.openModal();
        }
      });
    },
    async updateTrackingClient() {
      const result = await fetch(
        `${this.$store.state.apiUrl}clientRequest/requests/tracking`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.$store.state.token}`,
          },
          body: JSON.stringify({
            id: this.order[0].id,
          }),
        }
      );

      if (!result.ok) {
        const error = await result.json();
        console.error('Error:', error);
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Erro ao atualizar o tracking do cliente',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },
  async created() {
    console.log('AQUIIIIIIIIII');
    this.loading = true;
    await this.getTracking_fun();
    await this.productsOrder();
    await this.userRole();
    // await this.getAllProducts();
    await this.date();
    if (this.order[0].send_email == '' || this.order[0].send_email == null)
      await this.sendEmail();
    if (this.order[0].email == 'shebin.panikkaveetil@gmail.com')
      await this.updateTrackingClient();
    this.allArticles.forEach((article, idx) => {
      // if quantity was missing, default it to 1
      if (article.quantity === undefined) {
        this.$set(this.allArticles[idx], 'quantity', 1);
      }
      // add a closed flag
      this.$set(this.allArticles[idx], 'closed', false);
    });
    this.loading = false;
  },
  computed: {
    ...mapGetters(['getTracking']),
    ...mapGetters(['getProducts']),
    ...mapGetters(['getReturnedProducts']),
  },
};
</script>

<style scoped>
.card {
  padding: 25px;
  background-color: rgba(255, 147, 147, 0.733);
  margin: 50px;
  border: 1px solid #dddd;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  text-align: center;
}
.title {
  text-align: left;
  color: white;
}
h4 {
  color: white;
}
label {
  text-align: right;
}
#titleForm {
  text-align: left;
  color: white;
}
#send {
  text-align: right;
}
.form-group {
  margin: 20px;
}
a h3 {
  text-decoration: underline;
}
a h3:hover {
  text-decoration: none;
  cursor: pointer;
}
#processing {
  margin-right: 10px;
}
#finish {
  margin-left: 10px;
}
textarea {
  resize: none;
  margin-bottom: 20px;
}
#returnComment {
  margin-top: 10px;
}
#returnedProducts {
  margin-bottom: 10px;
}
</style>
